import { Apple, Play } from 'lucide-react';

export const APP_STORE_URL = 'https://apps.apple.com/app/gambgo/id6761062098';
export const PLAY_STORE_URL = 'https://play.google.com/store/search?q=gambgo&c=apps';

interface StoreBadgesProps {
  variant?: 'dark' | 'light';
  className?: string;
}

export const StoreBadges = ({ variant = 'dark', className = '' }: StoreBadgesProps) => {
  const base =
    'inline-flex items-center gap-3 rounded-2xl px-5 py-3 transition-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60';
  const skin =
    variant === 'dark'
      ? 'bg-landing-ink text-background shadow-lg'
      : 'bg-background text-landing-ink shadow-lg';

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`${base} ${skin}`}
        aria-label="Download GAMBGO on the App Store"
      >
        <Apple className="h-7 w-7" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wide opacity-70">Download on the</span>
          <span className="block text-base font-semibold">App Store</span>
        </span>
      </a>

      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`${base} ${skin}`}
        aria-label="Get GAMBGO on Google Play"
      >
        <Play className="h-6 w-6 fill-current" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] uppercase tracking-wide opacity-70">Get it on</span>
          <span className="block text-base font-semibold">Google Play</span>
        </span>
      </a>
    </div>
  );
};
